import { render, staticRenderFns } from "./TiposFreteTransportadora.vue?vue&type=template&id=5f2aa6e7"
import script from "./TiposFreteTransportadora.vue?vue&type=script&lang=js"
export * from "./TiposFreteTransportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports